(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tapis-details"] && !Shopify.designMode) return;
  try {
    function updateTapisDimensions(event){
  const variant=event.detail&&event.detail.variant;
  if(!variant)return;
  document.querySelectorAll('[data-tapis-current-size]').forEach(el=>{el.textContent=variant.title;});
}
document.addEventListener('variant:change',updateTapisDimensions);
  } catch(e) { console.error(e); }
})();

})();
